import { render, staticRenderFns } from "./ThePlantOverviewCard.vue?vue&type=template&id=59bd92ce"
import script from "./ThePlantOverviewCard.vue?vue&type=script&lang=js"
export * from "./ThePlantOverviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports